/**
 * Format payment method for display
 * Converts snake_case to Title Case (e.g., cash_app -> Cash App)
 */
export const formatPaymentMethod = (method) => {
  const methodMap = {
    'cash_app': 'Cash App',
    'cash_bank_deposit': 'Bank Deposit',
    'cash': 'Cash',
    'card': 'Card',
    'transfer': 'Transfer',
    'check': 'Paper Check',
    'online': 'Online',
    'zelle': 'Zelle',
    'venmo': 'Venmo',
  };
  return methodMap[method] || method;
};
